// Get backend URL from environment variable or use current origin
const getBackendURL = () => {
  // Always prefer environment variable
  if (process.env.REACT_APP_BACKEND_URL) {
    // Ensure it's HTTPS
    return process.env.REACT_APP_BACKEND_URL.replace(/^http:/, 'https:');
  }
  
  // Fallback to current origin (works for same-domain deployment)
  return window.location.origin;
};

export const BACKEND_URL = getBackendURL();

// Ensure all API calls use HTTPS
export const API_BASE = BACKEND_URL + '/api';

// Force HTTPS for all external resources
export const ensureHTTPS = (url) => {
  if (!url) return url;
  return url.replace(/^http:/, 'https:');
};
